import * as Vue from 'vue';

interface Component {
  [key: string]: Vue.Component;
}

export default class Dispatcher {
  components: Component;

  constructor(components: Component) {
    this.components = components;
  }

  dispatch(dispatchable: { $kind: string }): Vue.Component | null {
    if (!dispatchable) return null;
    return this.components[dispatchable['$kind']] || null;
  }
}
